import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'redo-annual-report',
    templateUrl: './redo-annual-report.component.html',
    styleUrls: ['./redo-annual-report.component.scss'],
})
export class RedoAnnualReportComponent implements OnInit {

    @Output() redoReport = new EventEmitter<void>();

    openRedoChangeConfirmationDialog: boolean = false;

    constructor() {}

    ngOnInit(): void {}


    confirmRedo(): void {
        this.openRedoChangeConfirmationDialog = false;
        this.redoReport.emit();
    }
    cancelRedo(): void {
        this.openRedoChangeConfirmationDialog = false;
    }

    openDialog(): void {
        this.openRedoChangeConfirmationDialog = true;
    }
}
